define(
({
  "select_shipping_method": "Sélectionner la méthode de livraison"
})
);
